export const getResourcesSize = (resources: PerformanceResourceTiming[]) => resources.reduce((acc, { encodedBodySize }) => acc + encodedBodySize, 0);
